<template>
    <div class="analysis-chart">
        <!-- 搜索条件 -->
        <el-form
            label-width="130px"
            size="mini">
            <!-- 时间选择 -->
            <el-form-item
                :label="$t('message.csales.search1')">
                <!-- 开始时间 -->
                <el-date-picker
                    v-model="form.start_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="handleStart"
                    :placeholder="$t('message.csales.place1')">
                </el-date-picker>
                <span style="margin: 0 5px;">-</span>
                <!-- 结束时间 -->
                <el-date-picker
                    v-model="form.end_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="handleEnd"
                    :picker-options="pickerOptions"
                    :placeholder="$t('message.csales.place2')">
                </el-date-picker>
            </el-form-item>
            <!-- 按钮 -->
            <el-form-item>
                <el-button
                    type="primary"
                    @click="handleSearch(form)">
                    {{$t("public.searchBtn")}}
                </el-button>
            </el-form-item>
        </el-form>
        <!-- 订单量表 -->
        <div class="analysis-chart-box"
            v-if="analysis_num.dimensions">
            <analysis-chart-echart
                :chart-name="$t('message.csales.chartName1')"
                :y-name="$t('message.csales.yName1')"
                series-type="line"
                :data-set="analysis_num">
            </analysis-chart-echart>
        </div>
        <!-- 订单金额表 -->
        <div class="analysis-chart-box"
            v-if="analysis_price.dimensions">
            <analysis-chart-echart
                :chart-name="$t('message.csales.chartName2')"
                :y-name="$t('message.csales.yName2')"
                series-type="bar"
                :data-set="analysis_price">
            </analysis-chart-echart>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    data() {
        let start_date = sessionStorage.getItem("start_date") || "",
        end_date = sessionStorage.getItem("end_date") || "";
        return {
            form: {
                start_date,
                end_date,
            },

            pickerOptions: {
                disabledDate:(time)=>{
                    return time.getTime() < new Date(this.form.start_date).getTime();
                }
            },
        }
    },
    computed: mapState({
        analysis_num: state => state.user.analysis.analysis_num,
        analysis_price: state => state.user.analysis.analysis_price
    }),
    components: {
        analysisChartEchart: () => import("@/components/center/analysisChartEchart")
    },
    methods: {
        ...mapActions([
            "getAnalysisChart"
        ]),
        handleStart(val){ // 开始日期
            if(this.form.end_date < val){
                this.form.end_date=""
            }
            sessionStorage.setItem("start_date", val);
            if(val == null){
                sessionStorage.removeItem("start_date")
            }
        },
        handleEnd(val){ // 结束日期
            sessionStorage.setItem('end_date', val);
            if(val == null){
                sessionStorage.removeItem("end_date");
            }
        },
        handleSearch(form){
            this.getAnalysisChart({
                release: form.start_date,
                relend: form.end_date
            })
        }
    },
}
</script>

<style scoped>
.analysis-chart-box{
    width: 100%;
    height: 500px;
    margin-top: 50px;
}
</style>